import styled from 'styled-components'
import theme from '../../styles/theme'

export const LoopStatic = styled.svg`
  height: 200px;
  @media screen and (max-width: ${theme.breakpoints.md}px) {
    height: 50px;
  }
`
